const part = [
    {
        path: 'recharge-fee-rate-list',
        name: 'recharge-fee-rate-list',
        meta: {
            icon: 'md-stats',
            title: '充值手续费费率',
            notCache: true,
            access: ['S', 'I', 'G'],
            items: [
            ]
        },
        component: () => import('@/view/finance-management/recharge-fee-rate/recharge-fee-rate-list')
    },
    {
	    path: 'recharge-fee-rate-record-list',
	    name: 'recharge-fee-rate-record-list',
	    meta: {
	        icon: 'md-stats',
	        title: '充值手续费费率记录',
	        notCache: true,
	        access: ['S', 'I'],
	        items: [
	        ]
	    },
	    component: () => import('@/view/finance-management/recharge-fee-rate/recharge-fee-rate-record-list')
    }
];

export default part;